


















































































































































import Vue from 'vue'
import { PlayerGameStatus, salaryExpectationClass } from '../types'
import Coin from './Coin.vue'

export default Vue.extend({
  name: 'Applications',
  props: [
    'status',
    'connections',
    'applications',
    'myPick',
    'currentApplicationIndex',
  ],
  components: {
    Coin,
  },
  data: function() {
    return {
      theplayerGameStatus: PlayerGameStatus,
      theSalaryExpectationClass: salaryExpectationClass,
    }
  },
  computed: {},
})
